module.exports = __webpack_public_path__ + "static/media/usersIcon.f6370f94.svg";